import {
    Component, OnInit, Renderer2, ElementRef, EventEmitter, Input,
    NgZone, ViewEncapsulation, ViewChild, OnDestroy, Output
} from '@angular/core';
import { Location } from '@angular/common';
import { CommonConstants } from '../common/utilities/commonConstants';
import { RouteContextProvider } from './../common/services/routeContextProvider.service';
import { EmitterService } from './../common/services/emitter.service';
import { SharedService } from './../common/services/sharedService';
import { CookieHandlerService } from './../common/services/cookieHandler.service';

@Component({
    selector: 'errorpage',
    // encapsulation: ViewEncapsulation.None,
    templateUrl: './errorpage.template.html',
    styleUrls: ['./errorpage.style.css'],
    providers: []
})

export class ErrorPageComponent implements OnInit {
    public IsHeaderAvailable: boolean;

    constructor(private _routeContextProvider: RouteContextProvider,
                private _emitterService: EmitterService,
                private _sharedService: SharedService,
                private _cookieHandler: CookieHandlerService,
                private _location: Location
                ) {
    }
    public ngOnInit(): void {
        this.IsHeaderAvailable = this._sharedService.getData('hideHeader');
        this._emitterService.Get(CommonConstants.EmitterEventTypes.
                        ServiceEvent).emit(this._sharedService.getData('hideHeader'));
    }
    public goBack(header) {
        let errorType = this._sharedService.getData('keyError');
        if (header === 'resume') {
            if (errorType === 1) {
                this._routeContextProvider.NavigateToView([CommonConstants.Routes.Home]);
                this._sharedService.setData('keyError', 0);
            } else {
                //let url = this._gotoRelationShipPage();
                this._routeContextProvider.NavigateToView([this._location.back]);
            }
        } else {
            this._emitterService.Get(CommonConstants.EmitterEventTypes.
                        ServiceEvent).emit(true);
            this._routeContextProvider.NavigateToView([CommonConstants.Routes.Home]);
        }
    }
}
